
import { apiSlice } from '../../api/apiSlice';

export const schoolApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllTeachersAccessibleSchools: builder.mutation({
      query: () => ({
        url: 'school/teacherAccessible',
        method: 'GET',
        credentials: 'include'
      })
    }),
    getAllCurrentStudents: builder.mutation({
      query: (options) => ({
        url: `/school/${options.schoolId}/search?${options.queryString}`,
        method: 'GET',
        credentials: 'include'
      })
    })
  })
});

export const {
  useGetAllTeachersAccessibleSchoolsMutation,
  useGetAllCurrentStudentsMutation
} = schoolApi;